import { Component, Input, OnInit, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ExportDataService } from '../../../../shared/services/export-data.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { DatePipe } from '@angular/common';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';
import { MaintenanceTableV4Component } from '../../maintenance-table-v4/maintenance-table-v4.component';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { AddEditForecastMultiMatrixComponent } from './add-edit-forecast-multi-matrix/add-edit-forecast-multi-matrix.component';


@Component({
    selector: 'app-forecast-multi-matrix',
    templateUrl: './forecast-multi-matrix.component.html',
    styleUrl: './forecast-multi-matrix.component.css',
    imports: [MatFormField, MatInput, FormsModule, LoaderComponent, MaintenanceTableV4Component, AppModalComponent, AddEditForecastMultiMatrixComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class ForecastMultiMatrixComponent implements OnInit {

  actionType: string = 'Add'; // Default action type
  showLoader: boolean = true; // Loader visibility flag
  selectedData: any = {}; // Object to hold selected data
  showModal: boolean = false; // Flag to control modal visibility
  @ViewChild('addEditMultiMatrix') addEditMultiMatrix: any;
  searchField: string = ''; // Search field for filtering data
  dataSourceDetails: MatTableDataSource<any> = new MatTableDataSource<any>([]); // Data source for the table
  oldDataSource: any[] = []; // Original data source to hold all data before filtering
  isResetFilter: boolean = false; // Flag to indicate if the filter has been reset
  @Input() isForecastAdmin: boolean = false;
  deleteData: Array<any> = []; // Array to hold data for deletion
  TABLE_CONFIG: any = {
    pageSize: [10, 20, 30],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    commonEdit: true,
    commonEditLabel: 'Click to Edit',
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    TABLE_CLASS: 'forecast-multi-matrix-table',
  };
  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit'
  };
  sortConfig = {
    active: 'SRVDESC',
    direction: 'asc'
  };

  TABLE_COLUMNS: any = [
    {
      key: 'SRVDESC',
      labelKey: "SRVDESC",
      label: 'Service Description',
      filter: false,
      align: 'left',
      sortable: false,
      search: '',
      searchValue: '',
      edit: false,
      class: 'space-between',
      validations: [{ 'required': false }]
    },
    {
      key: 'MULTI_SRV',
      labelKey: "MULTI_SRV",
      label: 'Service Id',
      filter: true,
      search: '',
      align: 'left',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'year',
      labelKey: "year",
      label: 'Year',
      filter: true,
      search: '',
      align: 'left',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'Jan',
      labelKey: "Jan",
      label: 'Jan',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }],
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Feb',
      labelKey: "Feb",
      label: 'Feb',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Mar',
      labelKey: "Mar",
      label: 'Mar',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Apr',
      labelKey: "Apr",
      label: 'Apr',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'May',
      labelKey: "May",
      label: 'May',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Jun',
      labelKey: "Jun",
      label: 'Jun',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Jul',
      labelKey: "Jul",
      label: 'Jul',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Aug',
      labelKey: "Aug",
      label: 'Aug',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Sep',
      labelKey: "Sep",
      label: 'Sep',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Oct',
      labelKey: "Oct",
      label: 'Oct',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Nov',
      labelKey: "Nov",
      label: 'Nov',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Dec',
      labelKey: "Dec",
      label: 'Dec',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      //type: 'numberFormat',
      //numberFormat: '1', // Format for number display
      validations: [{ 'required': false }],
      padding: '0.313rem 0.938rem 0.313rem 0.313rem !important'
    },
    {
      key: 'Updated_At',
      labelKey: "Updated_At",
      label: 'Updated At',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      sortable: true,
      edit: false,
      type: 'date',
      class: 'space-evenly',
      dateFormat: 'dd/MM/yyyy,h:mm a', // Format for date display with time
      validations: [{ 'required': false }]
    },
    {
      key: 'updatedByName',
      labelKey: "updatedByName",
      label: 'Updated By',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    }
  ];
  constructor(private exportService: ExportDataService, private toastr: ToastrService, private maintenanceService: MaintenanceService, private dialog: MatDialog, private datepipe: DatePipe) { }

  ngOnInit(): void {
    this.initializeData(); // Initialize data when the component is loaded
  }

  // Initialize data for the component
  initializeData() {
    if (this.isForecastAdmin) {
      this.addActions(); // Add actions column if it's a forecast admin
    }
    this.getTableData(); // Fetch the initial data for the table
  }

  // Add actions column to the table
  addActions() {
    this.TABLE_COLUMNS.unshift({
      key: 'select',
      matColumnDef: 'select',
      labelKey: "select",
      label: '',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      width: '5% !important',
      edit: false,
      validations: [{ 'required': false }],
    })
    this.TABLE_COLUMNS.push({
      key: 'Actions',
      labelKey: "Actions",
      label: 'Actions',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      width: '10% !important',
      edit: false,
      validations: [{ 'required': false }],
    });
  }

  //Search based on Service, User and Year
  searchDataSet() {
    const data = this.searchTableData(this.oldDataSource, this.searchField);
    this.dataSourceDetails = new MatTableDataSource(data);
  }

  //Get the data for list of forecast roles
  getTableData() {
    this.isResetFilter = false;
    this.searchField = ''; // Reset search field
    this.maintenanceService.getForecastMultiMatrixData().subscribe((data: any) => {
      this.handleTableData(data);
    }, (error) => {
      this.handleErrors(error);
    })
  }

  //Handle the sort change event
  // This function sorts the data based on the selected column and direction
  sortChangeEvent(sort: any) {
    if (sort.length > 0) {
      const key = sort[0][0]; // Get the key to sort by
      const direction = sort[0][1]; // Get the sort direction
      this.dataSourceDetails.data = _.orderBy(this.dataSourceDetails.data, [key], [direction]); // Sort the data based on the key and direction
      this.dataSourceDetails._updateChangeSubscription(); // Update the data source to reflect the changes
    }
  }

  //Handle the data received from the API
  handleTableData(data: any) {
    if (!data || data.length === 0) {
      data = []; // If no data is received, initialize it as an empty array
    }
    this.oldDataSource = data;
    this.dataSourceDetails = new MatTableDataSource(data);
    this.showLoader = false;
  }
  

  //Handle the errors while fetching the data
  handleErrors(_error: any) {
    this.showLoader = false;
    this.toastr.error('Error While Fetching Data', '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }

  //Search the data based on the search text
  searchTableData(items: any[], searchText: string): any[] {
    if (!items) {
      return []
    }
    if (searchText) {
      this.isResetFilter = true;
    } else {
      this.isResetFilter = false;
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => this.filterItem(item, searchText));
  }

  //Filter the items based on the search text
  // This function checks if the item matches the search criteria based on multiple fields
  filterItem(item: any, searchText: string): boolean {
    //searching based on Service and User & Year
    if (item.MULTI_SRV.toLowerCase().includes(searchText) || (item.SRVDESC && item.SRVDESC.toLowerCase().includes(searchText)) || item.year.toLowerCase().includes(searchText) || (item.updatedByName && item.updatedByName.toLowerCase().includes(searchText)) || (item.updatedById && item.updatedById.toLowerCase().includes(searchText))) {
      return true;
    } else {
      return false
    }
  }

  //Function when delete button is clicked
  // This function opens a confirmation dialog before deleting the selected records
  onDelete() {
    const idsToDelete = this.deleteData.map(item => item.Id); // Extract IDs from the selected data
    const subtitleMsg = idsToDelete.length > 1 ? 'Are you sure to delete these Records?' : 'Are you sure to delete the Record?';
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '25rem';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '12.5rem';
    dialogConfig.height = 'auto';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'Delete Confirmation!',
      subTitle: subtitleMsg,
      buttonName: 'Continue'
    };

    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if (result.data != 'cancel') {
        this.showLoader = true;
        this.callDeleteAction(idsToDelete); // Call the delete action with the extracted IDs
      }
    },
      (error) => {
        console.error(error);
      });
  }

  //Function to call the delete action
  // This function sends a request to delete the selected records and handles the response
  callDeleteAction(idsToDelete: Array<any>) {
    this.maintenanceService.deleteForecastMultiMatrixData({ Id: idsToDelete }).subscribe((res: any) => {
      let successMsg = 'Record Deleted Successfully';
      let errorMsg = 'Error While Deleting Record';
      if (idsToDelete.length > 1) {
        successMsg = 'Records Deleted Successfully';
        errorMsg = 'Error While Deleting Records';
      }
      if (res) {
        this.deleteData = []; // Clear the deleteData array after deletion
        this.refreshTable(); // Refresh the table data after deletion
        this.toastr.success(successMsg, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      } else {
        this.toastr.error(errorMsg, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
    });
  }

  //Function to handle checkbox click event
  // This function updates the deleteData array with the selected records for deletion
  checkboxClick(data: any) {
    this.deleteData = data.data;
  }

  //Open Modal to add new entry
  AddNewEntry() {
    this.showModal = true;
    this.actionType = 'Add';
    this.selectedData = null;
    this.openModal();
  }

  //Open the modal
  openModal() {
    this.addEditMultiMatrix.show();
  }

  //Export the table data to excel
  exportToExcel() {
    const exportData = [];
    this.oldDataSource.forEach((val) => {

      const exports = {};
      exports['Service Id'] = val.MULTI_SRV;
      exports['Service Description'] = val.SRVDESC;
      exports['Year'] = val.year;
      exports['January'] = val.Jan;
      exports['February'] = val.Feb;
      exports['March'] = val.Mar;
      exports['April'] = val.Apr;
      exports['May'] = val.May;
      exports['June'] = val.Jun;
      exports['July'] = val.Jul;
      exports['August'] = val.Aug;
      exports['September'] = val.Sep;
      exports['October'] = val.Oct;
      exports['November'] = val.Nov;
      exports['December'] = val.Dec;
      exports['Created At'] = val.createdAt ? this.datepipe.transform(val.createdAt, 'dd/MM/yyyy,h:mm a') : '';
      exports['Created By'] = val.createdByName;
      exports['Updated At'] = val.Updated_At ? this.datepipe.transform(val.Updated_At, 'dd/MM/yyyy,h:mm a') : '';
      exports['Updated By'] = val.updatedByName;
      exportData.push(exports);
    })
    this.exportService.exportToExcel('Forecast Multi Matrix', [exportData], ['Forecast Multi Matrix']);
  }

  //Handle the actions based on the edit icon click
  onEditClick(data: any) {
    this.showModal = true;
    this.actionType = 'Edit';
    this.selectedData = _.cloneDeep(data);
    this.openModal();
  }
  // Function to be called when the modal is closed
  closeModal() {
    this.showModal = false; // Hide the modal
    this.selectedData = {}; // Reset selected data
  }

  //Function to be called after save/update the multi matrix data
  saveMultiMatrix(_ev) {
    this.addEditMultiMatrix.hide();
    this.closeModal(); // Close the modal after saving
    this.refreshTable(); // Refresh the table data after saving
  }

  //Function to refresh the table data
  // This function clears the cached data and fetches the latest data for the table
  refreshTable() {
    this.showLoader = true; // Show loader while refreshing data
    this.maintenanceService.deleteCachedData('getForecastMultiMatrixData')
    this.getTableData(); // Refresh the table data
  }
}
